<template>
  <div>Loading...</div>
</template>
<script>
import { QUERY_USER, QUERY_TEAM, QUERY_GROUP, QUERY_PHONE_NUMBERS, QUERY_CALL_FLOW } from '@/graphql';
import { ROUTE_TYPES } from '@/constants';
import { getAvatarColor } from '@/utils';
export default {
  name: 'Redirect',
  components: {},
  async created() {
    const { token, id } = this.$route.query;
    if (!token || !id) {
      this.$router.push('/');
    }
    localStorage.setItem('token', token);
    this.$token = token;

    try {
      const {
        data: { users: manager }
      } = await this.$apollo.query({
        query: QUERY_USER,
        variables: {
          userId: id
        }
      });

      const me = {
        accountId: manager[0].account_id,
        avatarColor: getAvatarColor(),
        id: manager[0].id,
        email: manager[0].email,
        firstName: manager[0].first_name,
        lastName: manager[0].last_name,
        phoneNumber: manager[0].phone_number,
        onboardingStep: manager[0].onboarding_step,
        team: [],
        groups: manager[0].groups
      };

      await Promise.all([
        this.$store.dispatch('auth/setAuthenticated', {
          authenticated: true
        }),

        this.$store.dispatch('auth/setUser', {
          user: me
        }),

        this.$store.dispatch('onboarding/setOnboardingStep', me.onboardingStep)
      ]);

      const {
        data: { users }
      } = await this.$apollo.query({
        query: QUERY_TEAM,
        variables: {
          userId: id
        }
      });

      const team = users.map((user) => {
        return {
          id: user.id,
          avatarColor: getAvatarColor(),
          email: user.email,
          firstName: user.first_name,
          lastName: user.last_name,
          phone: user.phone_number,
          groups: user.groups
        };
      });

      await this.$store.dispatch('auth/setTeam', { team: [...team] });

      const allUsers = [me, ...team];

      const {
        data: { groups }
      } = await this.$apollo.query({
        query: QUERY_GROUP
      });

      const localGroups = groups.map((group) => {
        const members = allUsers.reduce((arr, user) => {
          if (user.groups.find((el) => el.id === group.id)) {
            arr.push({
              ...user,
              isAttached: true,
              avatarName: user.firstName.charAt(0) + user.lastName.charAt(0),
              name: `${user.firstName} ${user.lastName}`
            });
          }
          return arr;
        }, []);
        return {
          avatarColor: getAvatarColor(),
          avatarName: group.name.charAt(0),
          error: '',
          id: group.id,
          name: group.name,
          isCreated: true,
          localId: group.id,
          members
        };
      });

      await this.$store.dispatch('auth/setGroups', { groups: [...localGroups] });

      const {
        data: { phone_numbers }
      } = await this.$apollo.query({
        query: QUERY_PHONE_NUMBERS,
        variables: {
          accountId: me.accountId
        }
      });

      const selectedNumber = phone_numbers[0];
      await this.$store.dispatch('onboarding/setSelectedNumber', selectedNumber.phone_number);

      const numObject = {
        id: selectedNumber.id,
        name: selectedNumber.name,
        phoneNumber: selectedNumber.phone_number
      };

      await this.$store.dispatch('onboarding/setNumberObject', numObject);

      const {
        data: { callflows }
      } = await this.$apollo.query({
        query: QUERY_CALL_FLOW,
        variables: {
          phoneNumberId: numObject.id
        }
      });

      let step = me.onboardingStep;
      if (callflows[0]) {
        const callFlow = {
          type: ROUTE_TYPES.ROUTE_MENU,
          callMenu: [JSON.parse(callflows[0].open_flow), JSON.parse(callflows[0].closed_flow)],
          lineSchedule: JSON.parse(callflows[0].working_hours)
        };
        step = 4;

        await this.$store.dispatch('onboarding/setCallFlow', {
          ...callFlow
        });
      }

      const routes = ['/invite-team', '/create-groups', '/call-flow'];

      this.$router.push(routes[step - 2]);
    } catch (error) {
      console.log(error);
      this.$store.dispatch('auth/setAuthenticated', {
        authenticated: false
      });
      this.$router.push('/');
    }
  }
};
</script>
